import { Users } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const FleetSection = () => {
  const { t } = useLanguage();

  const cars = [
    {
      name: "VW Caddy",
      passengers: 6,
      image: "https://taxinora.se/new_assets/img/car/ODY633.jpg",
    },
    {
      name: "Mercedes E-klass",
      passengers: 4,
      image: "https://taxinora.se/new_assets/img/car/FCZ16J.jpg",
    },
    {
      name: "Mercedes V",
      passengers: 8,
      image: "https://taxinora.se/new_assets/img/car/BEY38W.jpg",
    },
    {
      name: "Toyota",
      passengers: 8,
      image: "https://taxinora.se/new_assets/img/car/HBF28Y.jpg",
    },
    {
      name: "Volvo V60",
      passengers: 4,
      image: "https://taxinora.se/new_assets/img/car/BKB25K.jpg",
    },
  ];

  return (
    <section id="bilar" className="section-spacing bg-neutral-950/50" data-testid="fleet-section">
      <div className="section-container">
        {/* Header */}
        <div className="text-left mb-16">
          <span className="text-yellow-500 text-sm font-semibold tracking-widest uppercase mb-4 block">
            {t.fleet.title}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {t.fleet.subtitle}
          </h2>
          <p className="text-neutral-400 text-lg max-w-2xl">
            {t.fleet.description}
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cars.map((car, index) => (
            <div
              key={car.name}
              className="car-card"
              data-testid={`car-card-${index}`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={car.image}
                  alt={car.name}
                  className="w-full h-[220px] object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-transparent to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-2">{car.name}</h3>
                <div className="flex items-center gap-2 text-neutral-400">
                  <Users className="w-4 h-4" />
                  <span>{t.fleet.seatsFor} {car.passengers} {t.fleet.passengers}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
